//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date :02/06/2025
// Version : 1
// Description : Pantalla donde estan los 3 tab con las 3 columnnas
//
//------Changes --------------------------------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/

import React, { useEffect, useState, useMemo } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Container,
  Typography,
  Box,
  Button,
  MenuItem,
  ListItemIcon,
} from "@mui/material";
import { Build } from "@mui/icons-material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import EditIcon from "@mui/icons-material/Edit";
import Notify from "../../Notify";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import SupportIcon from "@mui/icons-material/Support";
import AddReg from "./AddReg";
import EditarReg from "./EditarReg";
import ElegirTecnico from "./ElegirTecnico";
import ElegirCliente from "./ElegirCliente";
import PersonIcon from "@mui/icons-material/Person";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { v4 as uuidv4 } from "uuid"; //ADJUNTAR IMAGEN
import AttachFileIcon from "@mui/icons-material/AttachFile"; //ADJUNTAR ARCHIVOS
import FileUploadReguladores from "./FileUploadReguladores";
import Badge from "@mui/material/Badge";
import CambiarSucursal from "./CambiarSucursal";
import LlegoAlDestino from "./LlegoAlDestino";
import { useToast } from "../../../Hooks/UseToast";

function Reguladores_abm(props) {
  const [regulador, setRegulador] = useState(); //p/tabla
  const [alta, setAlta] = useState(false); //Estado q mostrará o no la pantalla de alta
  const [tabla, setTabla] = useState(true);
  const [editar, setEditar] = useState(false); //Estado q mostrará o no el form de edicion de choferes
  const [confirmar, setConfirmar] = useState(false);
  const [datosRegulador, setDatosRegulador] = useState({});
  const globalTheme = useTheme();
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [openSnack, setOpenSnack] = React.useState(false); //abre y cierra snack
  const [mensaje, setMensaje] = useState(""); //mensaje q mostrará la notif
  const [error, setError] = useState(null); //guardará el error que lance la api (si existe)
  const [obt, setObt] = useState(0);
  const [activeTab, setActiveTab] = useState(props.activeTab);
  const [asignar, setAsignar] = useState(false);
  const [cliente, setCliente] = useState(false);
  const [uuid, setUuid] = useState(""); // este UUID es el definitivo por regulador
  const [newUuid, setNewUuid] = useState(""); //ADJUNTAR COMPROBANTE
  const [openCloseAdj, setOpenCloseAdj] = useState(false); //ADJUNTAR COMPROBANTE
  const [sucursales, setSucursales] = useState([]); // Estado para almacenar en memoria el arreglo de sucursales
  const [mostrarModalDeCambioDeSucursal, setMostrarModalDeCambioDeSucursal] =
    useState(false); //Estado para abrir el modal de cambio de sucursal
  const [mostrarModalLlegoAlDestino, setMostrarModalLlegoAlDestino] =
    useState(false); //Estado para abrir el modal de llego al destino

  const { Toast, showToast } = useToast(); //Esto es para dejar las alertas visualmente mas lindas

  //*************************************************************************************************************************************/
  const obtenerRegulador = (estado) => {
    //ESTADO ===== 325 -> En planta 326 -> Asignado a instalacion 327 -> Instalada a cliente 329 -> En transito
    fetch(UrlApi + `/reguladores_abm/xEstado/${estado}`)
      .then((data) => data.json())
      .then((data) => setRegulador(data));
  };

  const obtenerSucursales = () => {
    fetch(UrlApi + `/sucursales`)
      .then((data) => data.json())
      .then((data) => {
        const sucurtsalesFiltradas = data.map(({ id, nombre }) => ({
          id,
          nombre,
        }));
        console.log(sucurtsalesFiltradas);
        setSucursales(sucurtsalesFiltradas);
      });
  };

  useEffect(() => {
    obtenerSucursales();
  }, []);

  const getRegulador = () => {
    switch (props.activeTab) {
      case 0:
        obtenerRegulador(324);
        break;

      case 1:
        obtenerRegulador(329);
        break;

      case 2:
        obtenerRegulador(325);
        break;
      case 3:
        obtenerRegulador(326);
        break;
      default:
        console.log("Error");
        break;
    }
  };

  useEffect(() => {
    setActiveTab(props.activeTab);
    getRegulador();
  }, [props.activeTab, tabla, obt]);

  const handleVolver = () => {
    setConfirmar(false);
    setTabla(true);
    getRegulador();
  };

  const handleClickNuevo = () => {
    const nuevoUuid = uuidv4(); // generar acá
    setUuid(nuevoUuid); // guardar en estado
    setAlta(true); // abrir formulario
    setTabla(false);
  };

  const handleOpenCloseAdj = (value) => {
    setOpenCloseAdj(value);
    getRegulador();
  };

  const handleOpenModalCambioSucursal = () => {
    setMostrarModalDeCambioDeSucursal(true);
  };

  const handleOpenModalLlegoAlDestino = () => {
    setMostrarModalLlegoAlDestino(true);
  };

  const mostrareditar = (datosDeLaLinea) => {
    setEditar(true);
    setTabla(false);
    setDatosRegulador(datosDeLaLinea);
    //console.log("datos linea",datosDeLaLinea ? datosDeLaLinea : "NO");
  };

  //**********************************************************************************/

  // PARA EL ESTADO PLANTA 324
  const getColumns = () => {
    let columns = [
      {
        header: "N° serie ",
        accessorKey: "nro_serie",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Marca",
        accessorKey: "descripcion_marca",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Modelo",
        accessorKey: "descripcion_modelos",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Pr.Entrada",
        accessorKey: "descrip_pres_entrada",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Pr.Salida",
        accessorKey: "descrip_pres_salida",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Caudal",
        accessorKey: "descrip_caudal",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Fabricación",
        accessorKey: "año_fabricacion",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Sucursal",
        accessorKey: "nombre_suc",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
    ];
    return columns;
  };
  const columns = useMemo(() => getColumns(regulador), [regulador]);

  // PARA EL ESTADO INSTALACION 325
  const getColumns2 = (reclamos) => {
    let columns2 = [
      {
        header: "N° serie ",
        accessorKey: "nro_serie",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Marca",
        accessorKey: "descripcion_marca",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Modelo",
        accessorKey: "descripcion_modelos",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Pr.Entrada",
        accessorKey: "descrip_pres_entrada",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Pr.Salida",
        accessorKey: "descrip_pres_salida",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Caudal",
        accessorKey: "descrip_caudal",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Fabricación",
        accessorKey: "año_fabricacion",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Instalador",
        accessorKey: "instalador",
        size: 200,
        muiTableBodyCellProps: { align: "left" },
      },
    ];
    return columns2;
  };

  const column2 = useMemo(() => getColumns2(regulador), [regulador]);

  // PARA EL ESTADO CLIENTE 326
  const getColumns3 = (reclamos) => {
    let columns3 = [
      {
        header: "N° serie ",
        accessorKey: "nro_serie",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Marca",
        accessorKey: "descripcion_marca",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Modelo",
        accessorKey: "descripcion_modelos",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Pr.Entrada",
        accessorKey: "descrip_pres_entrada",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Pr.Salida",
        accessorKey: "descrip_pres_salida",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Caudal",
        accessorKey: "descrip_caudal",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Cliente",
        accessorFn: (row) => `${row.sisven_id} - ${row.cliente}`,
        size: 250,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Fabricación",
        accessorKey: "año_fabricacion",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
    ];
    return columns3;
  };

  const column3 = useMemo(() => getColumns3(regulador), [regulador]);

  // PARA EL ESTADO CLIENTE 329
  const getColumnasEnTransito = (reclamos) => {
    let columnsEnTransito = [
      {
        header: "N° serie ",
        accessorKey: "nro_serie",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Marca",
        accessorKey: "descripcion_marca",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Modelo",
        accessorKey: "descripcion_modelos",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Pr.Entrada",
        accessorKey: "descrip_pres_entrada",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Pr.Salida",
        accessorKey: "descrip_pres_salida",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Caudal",
        accessorKey: "descrip_caudal",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Fabricación",
        accessorKey: "año_fabricacion",
        size: 90,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Sucursal origen",
        accessorKey: "nombre_suc",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Sucursal destino",
        accessorKey: "nombre_suc_des",
        size: 90,
        muiTableBodyCellProps: { align: "left" },
      },
    ];
    return columnsEnTransito;
  };

  const columnasEnTransito = useMemo(
    () => getColumnasEnTransito(regulador),
    [regulador]
  );

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode, //let's use the same dark/light mode as the global theme
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)" //background in light mode
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem", //override to make tooltip font size larger
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };
  const initialState = {
    //para inicializar la tabla, y la cantidad de paginas q se ven ej 5
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
    columnPinning: { right: ["mrt-row-actions"] },
  };
  const tableHeadCellProps = {
    align: "center",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  let filteredColumns = [];
  if (regulador) {
    if (props.activeTab === 0) {
      filteredColumns = columns;
    } else if (props.activeTab === 1) {
      filteredColumns = columnasEnTransito;
    } else if (props.activeTab === 2) {
      filteredColumns = column2;
    } else if (props.activeTab === 3) {
      filteredColumns = column3;
    }
  }

  return (
    <div>
      <Container maxWidth="xl" mt={1} mb={2}>
        {regulador && tabla ? (
          <Box mt={2} boxShadow={3}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                enableRowActions
                enableColumnResizing
                columns={filteredColumns}
                data={regulador}
                initialState={initialState}
                positionActionsColumn="last"
                enableExpandAll={false}
                enablePinning={false}
                enableToolbarInternalActions={true}
                muiTableHeadCellProps={tableHeadCellProps}
                muiTableBodyCellProps={({ row }) => ({
                  // align: "left",
                  sx: {
                    backgroundColor:
                      row.original.estado === 278 ? "#efc3c3" : "#b3e6b3",
                    color: "black",
                    borderColor: "black",
                  },
                })}
                enableColumnActions={false}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                enableDensityToggle={false}
                renderTopToolbarCustomActions={() => (
                  <>
                    {props.activeTab === 0 ? (
                      <div>
                        <Button
                          variant="contained"
                          color="primary"
                          startIcon={<AddBoxTwoToneIcon />}
                          onClick={handleClickNuevo}
                        >
                          Nuevo Regulador
                        </Button>
                      </div>
                    ) : null}
                    <Typography variant="poster" fontSize={26}>
                      <SupportIcon sx={{ size: 20 }} />
                      Stock de Reguladores
                    </Typography>
                  </>
                )}
                layoutMode="grid"
                localization={MRT_Localization_ES}
                enableColumnDragging={false} //No permite que se arrastren las columnas.
                // enableEditing
                // ACCIONES
                renderToolbarInternalActions={(
                  { table } // boton para nuevo , al lado del buscar
                ) => (
                  <>
                    <MRT_FullScreenToggleButton table={table} />
                  </>
                )}
                renderRowActionMenuItems={({ closeMenu, row }) => [
                  <MenuItem
                    disabled={props.activeTab === 2 || props.activeTab === 3}
                    key={7}
                    onClick={() => {
                      closeMenu();
                      setDatosRegulador(row.original);
                      handleOpenModalCambioSucursal();
                    }}
                    sx={{ m: 0 }}
                  >
                    <ListItemIcon>
                      <ChangeCircleIcon color="action" />
                    </ListItemIcon>
                    Cambiar de sucursal
                  </MenuItem>,
                  <MenuItem
                    disabled={
                      props.activeTab === 0 ||
                      props.activeTab === 3 ||
                      props.activeTab === 2
                    }
                    key={8}
                    onClick={() => {
                      closeMenu();
                      setDatosRegulador(row.original);
                      handleOpenModalLlegoAlDestino();
                    }}
                    sx={{ m: 0 }}
                  >
                    <ListItemIcon>
                      <LocalShippingIcon sx={{ color: "#0080ff" }} />
                    </ListItemIcon>
                    Llego a destino
                  </MenuItem>,
                  <MenuItem
                    disabled={
                      props.activeTab === 2 ||
                      props.activeTab === 3 ||
                      props.activeTab === 1
                    }
                    key={0}
                    onClick={() => {
                      closeMenu();
                      setDatosRegulador(row.original);
                      setAsignar(true);
                      setNewUuid(row.original.uuid); //el uuid del regulador real
                    }}
                    sx={{ m: 0 }}
                  >
                    <ListItemIcon>
                      <Build color="action" />
                    </ListItemIcon>
                    Asignar Técnico
                  </MenuItem>,

                  <MenuItem
                    disabled={
                      props.activeTab === 0 ||
                      props.activeTab === 3 ||
                      props.activeTab === 1
                    }
                    key={1}
                    onClick={() => {
                      closeMenu();
                      setDatosRegulador(row.original);
                      setAsignar(true);
                      setNewUuid(row.original.uuid); //el uuid del regulador real
                    }}
                    sx={{ m: 0 }}
                  >
                    <ListItemIcon>
                      <Build sx={{ color: "red" }} />
                    </ListItemIcon>
                    Reasignar Técnico
                  </MenuItem>,

                  <MenuItem
                    disabled={
                      props.activeTab === 0 ||
                      props.activeTab === 3 ||
                      props.activeTab === 1
                    }
                    key={2}
                    onClick={() => {
                      closeMenu();
                      setDatosRegulador(row.original);
                      setCliente(true);
                      setNewUuid(row.original.uuid); //el uuid del regulador real
                    }}
                    sx={{ m: 0 }}
                  >
                    <ListItemIcon>
                      <PersonAddAlt1Icon sx={{ color: "green" }} />
                    </ListItemIcon>
                    Asignar Cliente
                  </MenuItem>,

                  <MenuItem
                    disabled={
                      props.activeTab === 0 ||
                      props.activeTab === 2 ||
                      props.activeTab === 1
                    }
                    key={3}
                    onClick={() => {
                      closeMenu();
                      setDatosRegulador(row.original);
                      setCliente(true);
                      setNewUuid(row.original.uuid); //el uuid del regulador real
                    }}
                    sx={{ m: 0 }}
                  >
                    <ListItemIcon>
                      <PersonIcon sx={{ color: "green" }} />
                    </ListItemIcon>
                    Reasignar Cliente
                  </MenuItem>,

                  <MenuItem
                    key={4}
                    onClick={() => {
                      mostrareditar(row.original);
                      closeMenu();
                    }}
                  >
                    <ListItemIcon>
                      <EditIcon color="primary" />
                    </ListItemIcon>
                    Editar
                  </MenuItem>,
                  <Badge
                    key={5}
                    color="primary"
                    badgeContent={row.original.total_archivos} // Muestra el número correcto de adjuntos
                    showZero
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: "0.75rem", // Tamaño de fuente más pequeño
                        minWidth: "17px", // Ancho mínimo del badge
                        height: "17px", // Alto mínimo del badge
                        padding: "0 3px", // Padding ajustado para el contenido
                        transform: "translateX(32px)", // Desplaza el badge hacia la derecha
                      },
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        setNewUuid(row.original.uuid);
                        setOpenCloseAdj(!openCloseAdj);
                        closeMenu();
                      }}
                    >
                      <ListItemIcon>
                        <AttachFileIcon color="action" />
                      </ListItemIcon>
                      Adjuntos
                    </MenuItem>
                  </Badge>,
                ]}
              />
            </ThemeProvider>
            <br />
            <br />
          </Box>
        ) : null}

        {mostrarModalDeCambioDeSucursal ? (
          <CambiarSucursal
            showToast={showToast}
            data={datosRegulador}
            open={mostrarModalDeCambioDeSucursal}
            onClose={() => {
              setMostrarModalDeCambioDeSucursal(false);
            }}
            sucursales={sucursales}
            getRegulador={getRegulador}
          />
        ) : null}
        {mostrarModalLlegoAlDestino ? (
          <LlegoAlDestino
            showToast={showToast}
            data={datosRegulador}
            open={mostrarModalLlegoAlDestino}
            onClose={() => {
              setMostrarModalLlegoAlDestino(false);
            }}
            getRegulador={getRegulador}
          />
        ) : null}

        {notificacion ? (
          <Notify
            mensaje={mensaje}
            open={openSnack}
            color={"#D4EFDF"}
            severity={"success"}
            handleClose={handleVolver}
          />
        ) : null}

        {alta ? <AddReg alta={setAlta} tabla={setTabla} uuid={uuid} /> : null}
        {editar ? (
          <EditarReg
            editar={setEditar}
            tabla={setTabla}
            datos={datosRegulador}
            actualizar={setObt}
          ></EditarReg>
        ) : null}
        {asignar ? (
          <ElegirTecnico
            datos={datosRegulador}
            open={asignar} // Pasa el estado booleano
            setOpen={setAsignar} // Pasa la función para actualizar el estado
            tabla={setTabla}
            actualizar={getRegulador}
            activeTab={activeTab}
            uuid={uuid}
            newUuid={newUuid}
          />
        ) : null}
        {cliente ? (
          <ElegirCliente
            datos={datosRegulador}
            open={cliente} // Pasa el estado booleano
            setOpen={setCliente} // Pasa la función para actualizar el estado
            tabla={setTabla}
            actualizar={getRegulador}
            activeTab={activeTab}
            uuid={uuid}
            newUuid={newUuid}
          />
        ) : null}
        {openCloseAdj ? ( // ADJUNTAR COMPROBANTES
          <FileUploadReguladores
            fileId={newUuid}
            openclose={true}
            mostrar={true}
            onClose={() => handleOpenCloseAdj(false)} // Proporciona una función de cierre
          />
        ) : null}
      </Container>
      {Toast}
    </div>
  );
}

export default Reguladores_abm;
